import { DynamicStandaloneCoverBox } from '@/components/CoverBox';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { convertLinkFormat } from 'base/components/CoverBox/helpers';
import { renderContentComponent } from 'modules/dynamic/components';

const LabradorCoverBox: LabradorComponent = ({ type, meta, data, descendants }) => {
  const images = descendants.map(renderContentComponent);

  return (
    <DynamicStandaloneCoverBox
      headline={data.title}
      bodyText={convertLinkFormat(data.bodytext || '')}
      images={images}
      options={data.options || {}}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorCoverBox;
